import {TweenLite} from 'gsap';

// const analyticsEvent = require('../../viscomjs/analytics/analyticsEvent');



const ScrollArrow = require('../../viscomjs/ui/ScrollArrow');
const SectionsController = require('./SectionsController');
const DataUtils = require('../../viscomjs/utils/data');
const SandwichUI = require('./components/SandwichUI');
const Pagination = require('./components/Pagination');
const TipsAnimation = require('./components/TipsAnimation');


const Watermark = require('./components/Watermark');
const body = document.body;
let paginationUI;
let sandwichUI;
let sandwichUIClose;
let nextBtnMain;
let nextBtnCover;
// let nextBtnsLong;
let curIndex = 0;
const sections = [...document.querySelectorAll('.section')];
const _longSectionsIndices = [];
const _longProgress = [];
const _stopWMs = [];

function _initUI() {
    const _next = () => {
        SectionsController.next();
    };

    const _scrollLong = () => {
        SectionsController.scrollLong();
    };

    nextBtnMain = ScrollArrow(document.querySelector('.js-next--main'));
    nextBtnCover = ScrollArrow(document.querySelector('.js-next--cover'));

    const els = [...document.querySelectorAll('.js-scroll--long')];
    /* nextBtnsLong = */els.map(el => {
        const scrollArrow = ScrollArrow(el);
        scrollArrow.onClick(_scrollLong);
        return  scrollArrow;
    });

    sandwichUI = SandwichUI(document.querySelector('.sandwich'));
    sandwichUIClose = SandwichUI(document.querySelector('.nav .sandwich'));

    paginationUI = Pagination(document.querySelector('.nav .pagination'));

    nextBtnMain.disable();
    nextBtnCover.disable();

    nextBtnMain.onClick(_next);
    nextBtnCover.onClick(_next);


}

function _initController() {
    body.dataset.cover = true;

    SectionsController.init();
    SectionsController.onChange((index, prevIndex) => {
        if (prevIndex > -1 && prevIndex < sections.length) {
            TweenLite.delayedCall(0.75, _stopWMs[prevIndex]);

            if (prevIndex === 0) body.dataset.cover = false;
        }
        if (index < 0 || index > sections.length - 1) return;

        if (index === 0) body.dataset.cover = true;

        sandwichUI.close();

        curIndex = index;
        _updateUI(curIndex);
        _startWM(index);
    });


    SectionsController.onLongProgressChanged((i, progress) => {

        const index = _longSectionsIndices[i];
        _longProgress[index] = progress;
        _updateUI(curIndex);
    });
}

function _initSections() {

    sections.forEach((section, index) => {
        if (_checkIfIsALongSection(index)) {
            _longSectionsIndices.push(index);
        }
        _longProgress[index] = 0;

        _initSectionWMs(section);
        _stopWMs[index] = () => {
            _stopWM(index);
        }
    })

}

function _initSectionWMs(section) {
    const wmEl = section.querySelector('.wm');
    if (!wmEl) return;

    const wm = Watermark(wmEl);
    wm.init();
    DataUtils.setData(section, 'wm', wm);
}

function _startWM(index) {
    const wm = DataUtils.getData(sections[index], 'wm');
    TweenLite.killDelayedCallsTo(_stopWMs[index]);
    if (wm) wm.start();
}

function _stopWM(index) {
    const wm = DataUtils.getData(sections[index], 'wm');
    if (wm) wm.stop();
}

function init() {

    _initUI();
    _initController();
    _initSections();

    return this;
}

function start() {

    SectionsController.start();

    sandwichUI.enable();
    paginationUI.enable();
    sandwichUIClose.enable();
    _addListeners();

    TipsAnimation.onComplete(() => {
        nextBtnCover.enable();
        nextBtnCover.show();
        TipsAnimation.destroy();
    });

    TipsAnimation.start(0.75);

    _startWM(0);

    return this;
}

function _addListeners() {

    paginationUI.on('changed', _handlePagination)


    //  BOSS watermark test


    /* document.body.addEventListener('click', evt => {
 console.log(evt)
        WM.changeVelocityTo(-WM.getVelocity());
    })*/
}

function _handlePagination(index) {
    sandwichUI.close();
    SectionsController.goto(index);
}

function _updateUI(index) {

    if (index === 0) {
        body.dataset.longInProgress = false;
        nextBtnCover.enable();
        nextBtnMain.disable();
        return;
    }
    if (_checkIfIsEnd(index)) {
        body.dataset.longInProgress = false;
        nextBtnCover.disable();
        nextBtnMain.disable();
        return;
    }

    nextBtnCover.disable();
    if (_checkIfIsALongSection(index) && _longProgress[index] < 0.99) {
        body.dataset.longInProgress = true;
        nextBtnMain.disable();
    } else {
        body.dataset.longInProgress = false;
        nextBtnMain.enable();
    }
}

function _checkIfIsALongSection(index) {
    if (index < 0 || index > sections.length - 1) return false;
    return sections[index].classList.contains('section--type-long');
}

function _checkIfIsEnd(index) {
    return index >= sections.length - 1;
}


const Project = {};

Project.init = init.bind(Project);
Project.start = start.bind(Project);

module.exports = Project;


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/ProjectSingleton.js